module.exports = __webpack_public_path__ + "static/media/topCarouselBgVideoThumbnail.5e78a3d0.jpg";